import { useEffect, useState } from 'react'
import { subscribeDemoFreeze } from '../../../services/ownerConsoleService'
import type { OwnerDemoFreeze } from '../../../services/ownerConsoleSettingsModel'

export type DemoFreezeState = { freeze: OwnerDemoFreeze | null; loading: boolean; error: string | null }

const messageOf = (error: unknown): string =>
  error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error'

/** Live `system/config.demoFreeze` (the owner settings document). */
export function useDemoFreeze(enabled: boolean): DemoFreezeState {
  const [state, setState] = useState<{ freeze: OwnerDemoFreeze | null; error: string | null } | null>(null)

  useEffect(() => {
    if (!enabled) return undefined
    return subscribeDemoFreeze(
      (freeze) => setState({ freeze, error: null }),
      (error) => setState({ freeze: null, error: messageOf(error) }),
    )
  }, [enabled])

  return { freeze: state?.freeze ?? null, loading: enabled && state === null, error: state?.error ?? null }
}
